/**
 * Object iterator. It actually passes the type of the object to the resulting array.
 * This function will pass all the properties of the object as a array of objects.
 * @param object Object to iterate on.
 */
export function objectIterator<T>(object: { [key: string]: T }): T[] {
	return Object.keys(object).map((key: string) => object[key]);
}